module.exports = __webpack_public_path__ + "img/noClass.4236c0a8.png";